export const colors = {
    black: '#333333',
    blackBg: '#121212',
    white: '#ffffff',
    grey: '#9E9E9E',
    greyLight: '#F9F9F9',
    greyDark: '#606060'
};



// WEBPACK FOOTER //
// ./src/styles/colors.js